import { State } from '../configure-store';
import { getTeamName } from './teamDetails';
import { getIsSite } from './config';

export const getShouldShowFirstTimeExperience = (state: State) =>
  !getIsSite(state) && (!getTeamName(state) || state.debug && window.location.search.includes('showWelcome'));
